import React from 'react'
import clsx from 'clsx'
import { CalendarEdit } from 'iconsax-react'
import { formatDateRelative } from '@SonarCX/utilities'
import { useTheme } from '@mui/material'

const UpdatedAtSection = ({ classes, values }) => {
  const theme = useTheme()
  return (
    <div
      className={clsx(
        classes.center,
        classes.label,
        classes.mobile,
        classes.container
      )}
      style={{ cursor: 'default' }}
    >
      <span className={clsx(classes.center, classes.label)}>
        <CalendarEdit
          variant='Bulk'
          size={theme.size.base}
          color={theme.palette.primary.main}
        />{' '}
        UPDATED AT
      </span>

      <div>{formatDateRelative(values?.updated_at, true)}</div>
    </div>
  )
}

export default UpdatedAtSection
